import { apiFetch } from './client'
import type { ApplicationResponse, ApplicationWithDocuments, SectionSlug, SessionResponse } from './types'

export function requestOtp(email: string): Promise<{ ok: boolean }> {
  return apiFetch('/api/v1/applicant/auth/otp', {
    method: 'POST',
    body: JSON.stringify({ email }),
  })
}

export function verifyOtp(email: string, code: string): Promise<SessionResponse> {
  return apiFetch('/api/v1/applicant/auth/verify', {
    method: 'POST',
    body: JSON.stringify({ email, code }),
  })
}

export function exchangeMagicToken(token: string): Promise<SessionResponse> {
  return apiFetch('/api/v1/applicant/auth/magic', {
    method: 'POST',
    body: JSON.stringify({ token }),
  })
}

export function me(): Promise<SessionResponse> {
  return apiFetch('/api/v1/applicant/auth/me')
}

export function logout(): Promise<{ ok: boolean }> {
  return apiFetch('/api/v1/applicant/auth/logout', { method: 'POST' })
}

export function getApplication(): Promise<ApplicationResponse> {
  return apiFetch('/api/v1/applicant/application')
}

export function saveApplication(input: {
  form_data?: Record<string, unknown>
  current_section?: SectionSlug
}): Promise<{ application: NonNullable<ApplicationResponse['application']> }> {
  return apiFetch('/api/v1/applicant/application', {
    method: 'PATCH',
    body: JSON.stringify(input),
  })
}

export function submitApplication(): Promise<{ application: NonNullable<ApplicationResponse['application']> }> {
  return apiFetch('/api/v1/applicant/application/submit', { method: 'POST' })
}

/** Every application the account has (newest first), with document summaries. */
export function listApplications(): Promise<{ applications: ApplicationWithDocuments[] }> {
  return apiFetch('/api/v1/applicant/applications')
}

/** Deliberately start a fresh draft after a submission (idempotent: returns
 *  the existing draft when one is already in progress). */
export function createApplication(): Promise<{ application: NonNullable<ApplicationResponse['application']> }> {
  return apiFetch('/api/v1/applicant/applications', { method: 'POST' })
}
